import { useCreateBillingUnitsMutation, useEditBillingUnitsMutation } from "../../../api/billingUnitApi";

/**
 * Data/API Layer - mirrors _features/markets/modals/MarketFormModal/
 * hooks/useMarketFormMutations.js. Create/edit only - same as Markets, no
 * logo upload or extra branches.
 */
export function useBillingUnitFormMutations() {
  const [createBillingUnit, { isLoading: isCreating }] = useCreateBillingUnitsMutation();
  const [updateBillingUnit, { isLoading: isUpdating }] = useEditBillingUnitsMutation();

  async function submitBillingUnit({ mode, validData, rowData }) {
    if (mode === "create") {
      return await createBillingUnit(validData).unwrap();
    }

    return await updateBillingUnit({ ...validData, orgId: rowData?.orgId, _id: rowData?._id }).unwrap();
  }

  return {
    submitBillingUnit,
    isSubmitting: isCreating || isUpdating,
  };
}
